module.exports = __webpack_public_path__ + "img/16.e80a5db3.png";